import {Component, Input} from '@angular/core';

import {SubtitlesService, ViewsService, ZonesService} from "../../core";
import {DWHTileType100} from "../../models";

@Component({
    selector: 'dhw-for-zones',
    templateUrl: './dhw-for-zones.component.html',
    styleUrls: ['./dhw-for-zones.component.scss']
})
export class DhwForZonesComponent {
    @Input() tile: DWHTileType100;

    constructor(
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }
}
